import React from "react";

function StraightenIcon({ fill, ...restProps }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={fill ?? ""}
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M6.38879 18.138V12.6553C5.59293 13.4672 4.92701 14.4694 4.63627 14.9907C4.02208 16.1933 3.91944 17.59 3.94489 18.138H6.38879Z"
        fill="#98A2B3"
      />
      <path
        d="M14.0331 18.138V12.6553C14.8289 13.4672 15.4949 14.4694 15.7856 14.9907C16.3998 16.1933 16.5024 17.59 16.477 18.138H14.0331Z"
        fill="#98A2B3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.78835 5.81514C9.63186 6.09391 9.0401 6.71309 7.925 6.95957C7.57959 7.04127 6.86465 7.38113 6.76816 8.08701C6.64755 8.58214 6.61201 9.81363 7.43469 10.7785C7.63782 11.0303 8.2396 11.6101 9.02166 11.9148C8.86296 12.0058 8.33355 12.2131 7.48548 12.3147C7.09703 12.3457 6.21989 12.3948 5.81889 12.3431C5.61129 12.3077 5.17256 12.1487 5.07838 11.7963C4.82657 11.3075 4.40349 9.82594 4.72565 7.80982C5.00086 6.21146 6.37037 2.92247 9.6468 2.55351C10.889 2.33212 13.7183 2.68817 15.0983 5.88343C15.6333 6.91262 16.4358 9.55975 15.3658 11.9148C15.2761 12.0626 14.969 12.3581 14.4576 12.3581H14.4312L12.9046 12.3264C12.5982 12.2595 11.8851 12.0929 11.4836 11.9619C12.1528 11.7648 13.5421 10.8886 13.7461 8.96087C13.7838 8.70079 13.8156 8.11668 13.6417 7.86081C13.5825 7.7312 13.3537 7.47701 12.9122 7.49708C12.6028 7.50373 11.8427 7.44447 11.2767 7.15416C10.8745 7.01187 10.0136 6.54486 9.78835 5.81514ZM7.18391 5.62574C8.19026 4.96311 10.8004 4.04711 13.1901 5.68421C12.8641 5.11725 11.8018 4.00778 10.1604 4.10558C9.54919 4.08255 8.09813 4.35433 7.18391 5.62574Z"
        fill="#98A2B3"
      />
      <path
        d="M9.30286 13.582C8.52872 13.582 7.86391 12.7429 7.70435 12.3706L7.70312 15.4076H12.7746V12.3677C12.212 13.3652 11.5336 13.5929 11.2647 13.582C10.7825 13.6411 10.3744 13.2226 10.2306 13.0059C9.91387 13.5141 9.48013 13.6017 9.30286 13.582Z"
        fill="#98A2B3"
      />
    </svg>
  );
}
export default StraightenIcon;
